import { Card, Container, HStack, Image, Text, VStack, Button, Stack } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

export default function OrderDetails() {

    const { state } = useLocation();

    return (
        <Container maxW='5xl' py='8'>

            <VStack spacing={5}>

                <HStack pt='2' alignItems='start' justifyContent='end' w='100%'>


                    <Card w='100%' p='5'>
                        <VStack w='100%' spacing={2} alignItems={'start'}>
                            <Text fontWeight='bold'>Address Details</Text>
                            <Text> Address : {state.address}</Text>
                            <Text> City : {state.city}</Text>
                            <Text> State : {state.state}</Text>
                            <Text> Country : {state.country}</Text>
                            <Text> Zip Code : {state.pincode}</Text>
                        </VStack>
                    </Card>
                </HStack>

                <HStack>
                    {/* Download Invoice button  */}
                    {state.invoice_url && (
                        <Button
                            bg="#1c1c1c"
                            _hover={{ bg: '#1d1d1d' }}
                            color="#fefefe"
                            py='6'
                            width='100%'
                            borderRadius='0'
                            onClick={() => {
                                const link = document.createElement('a');
                                link.href = state.invoice_url;
                                link.download = 'invoice.pdf';
                                link.target = '_blank';
                                link.click();
                            }}
                        >
                            Download Invoice

                        </Button>
                    )}

                    {/* Download Invoice button  */}
                    {state.tracking_url && (
                        <Button
                            bg="#1c1c1c"
                            _hover={{ bg: '#1d1d1d' }}
                            color="#fefefe"
                            py='6'
                            width='100%'
                            borderRadius='0'
                        >
                            <a
                                href={`https://${state.tracking_url}`}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                Track Order
                            </a>
                        </Button>
                    )}

                </HStack>

                <Text fontSize='2xl' fontWeight='bold'>Order Details</Text>

                <Card w='100%' p='5'>
                    <VStack w='100%' spacing={2} alignItems={'start'}>
                        <Text>Order Details</Text>
                        <Text> Status : {state.status}</Text>
                        <Text> Order Date : {moment(state.created_at).format('DD-MM-YYYY')}</Text>
                        <Text fontWeight='bold'> Order ID : {state.id}</Text>
                        <Text fontWeight='bold'> Order Total : Rs {state.total}</Text>
                        <Text fontWeight='bold'> Order Items : {state.order_details.length}</Text>
                        <Text fontWeight='bold'> Payment Method : {state.payment_method}</Text>
                        <Text fontWeight='bold'> Payment Status : {state.payment_id ? 'Paid' : 'Unpaid'}</Text>
                        <Text fontWeight='bold'> Payment ID : {state.payment_id}</Text>
                        <Text color='muted'>Can be used to align this order on razorpay dashboard</Text>
                    </VStack>
                </Card>

                <Text fontSize='2xl' fontWeight='bold'>Order Items</Text>

                {state.order_details.map((order) => (
                    <Card w='100%' p='5'>
                        <Stack w='100%' direction={{ base: 'column', md: 'row' }} justifyContent='space-between'>
                            <Image src={order.product_details[0].product_variants.image1} alt='product' w='200px' />

                            <VStack w='100%' spacing={2} alignItems={'start'} ms='4'>
                                <Text fontSize='md'>Product Details</Text>
                                <Text fontSize='md'>Quantity : {order.quantity}</Text>
                                <Text fontSize='md'>Product Name : {order.product_details[0].products.name}</Text>
                                <Text fontSize='md'>Description : {order.product_details[0].products.description}</Text>
                                <Text fontSize='md'>Mrp : {order.product_details[0].product_variants.mrp}</Text>
                                <Text fontSize='md'>Selling Price : {order.product_details[0].product_variants.selling_price}</Text>
                                <Text fontSize='md'>Color : {order.color}</Text>
                                <Text fontSize='md'>Size : {order.size}</Text>
                                {/* <Text>Image : {order.product_details[0].product_variants.image1}</Text> */}
                            </VStack>
                        </Stack>
                    </Card>
                ))}

                {/* <p>{JSON.stringify(state)}</p> */}

            </VStack>
        </Container >
    )
}
